import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom"
import { DialogTitle } from "@mui/material"
import UnifiedSearch from "modules/unified-search"
import { Creators as RootCreators } from "modules/portfolio-root/model"
import { Creators as CompositeCreators, Types as CompositeTypes } from "model/compositeSecurity"
import { isCompositeSecurity } from "helpers/compositeSecurities"
import ModelSelectorAutocomplete from "connected-components/model-selector-autocomplete"

export default function HomeSearch({ account, close, model, setModel, models, openSecurityProfile, openFactorProfile, disableModel }) {
  const navigate = useNavigate()

  const emptySearch = <div className="compare-search-empty">
    Search Portfolios, watchlists, baskets, securities or ETFs
  </div>

  // [TODO]: find a better solution to manage the availability of the model selector depending on which screen you are in the app
  const disableModelSelection = disableModel || window.location.pathname.indexOf("/home/") === -1

  const itemActions = {
    security: {
      mainAction: item => () => {
        if (item.assetClass === "currency") {
          openFactorProfile(item.ticker)
        } else {
          openSecurityProfile(item.assetClass, item.ticker, item.ticker, item.exchange)
        }
        return close()
      },
      secondaryAction: item => isCompositeSecurity(item) ? () => CompositeCreators.openCompositeSecurity(account, item, false, model) : null,
      secondaryActionType: CompositeTypes.OPEN_COMPOSITE_SECURITY,
    },
    index: {
      secondaryAction: item => () => CompositeCreators.openCompositeSecurity(account, item, false, model),
      secondaryActionType: CompositeTypes.OPEN_COMPOSITE_SECURITY,
    },
    factor: {
      mainAction: item => () => openFactorProfile(item.id),
      secondaryAction: item => () => RootCreators.toggleFavoriteFactor(item.id, model),
    },
    portfolio: {
      mainAction: item => () => {
        navigate(`/${account}/p/${item.alias || item.id}`)
        return close()
      },
      dashboardAction: item => () => {
        navigate(`/${account}/dashboard?instrumentType=portfolio&instrumentId=${item.alias || item.id}`)
        return close()
      },
    },
    researchTopic: {
      mainAction: item => () => {
        navigate(`/${account}/t/${item.id}`)
        return close()
      },
    },
    watchlist: {
      mainAction: item => () => {
        navigate(`/${account}/watchlist/${item.alias || item.id}`)
        return close()
      },
    },
  }

  return <div className="modules_home-search">
    <DialogTitle>
      <span>Search</span>
      <ModelSelectorAutocomplete
        models={models}
        value={model}
        onChange={setModel}
        disabled={disableModelSelection}
      />
    </DialogTitle>
    <UnifiedSearch
      disablePortal
      skipClose
      autoFocus
      account={account}
      modelId={model}
      itemsActions={itemActions}
      onSelect={close}
      emptyContent={emptySearch}
    />
  </div>
}

HomeSearch.propTypes = {
  close: PropTypes.func,
  account: PropTypes.string.isRequired,
  openSecurityProfile: PropTypes.func.isRequired,
  model: PropTypes.string.isRequired,
  setModel: PropTypes.func.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  models: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  })).isRequired,
  disableModel: PropTypes.bool,
}
